import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ContactSection } from '../contact/ContactSection';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-white dark:bg-[#0C0C0C]" data-id="element-734">
      <Header data-id="element-735" />
      <main className="flex-grow" data-id="element-736">
        {children}
        <ContactSection data-id="element-737" />
      </main>
      <Footer data-id="element-738" />
    </div>;
}